// extracted by mini-css-extract-plugin
module.exports = {"translationDisclaimer":"style_translationDisclaimer__Cc9Wy"};